import { useState, useCallback, JSX, useMemo } from 'react';
import { mergeWith, isArray } from 'lodash';

import { TInitDataContext } from 'domain/types';

const customizer = (objValue: any, srcValue: any) => {
  if (isArray(objValue)) {
    return srcValue;
  }

  return undefined;
};

type TCreateProviderCbArgs = {
  children: JSX.Element[] | JSX.Element;
};

export const createProvider = (Context: any, initState: TInitDataContext<any> | object = {}) => {
  return ({ children }: TCreateProviderCbArgs) => {
    const [state, setState] = useState(initState);

    const update = useCallback(
      (parts: any) => {
        setState((innerState) => {
          return mergeWith({}, innerState, parts, customizer);
        });
      },
      [setState]
    );

    const reset = useCallback(() => {
      setState(initState);
    }, [setState]);

    const providerValue = useMemo(() => {
      return {
        ...state,
        update,
        reset,
      };
    }, [state, update, reset]);

    return <Context.Provider value={providerValue}>{children}</Context.Provider>;
  };
};
